export default function initCalcHeaderHeight() {
  const body = document.body;
  const header = body?.querySelector('.header');

  let headerHeight = header.offsetHeight;

  body.style.setProperty('--header-height', `${headerHeight}px`);

  window.addEventListener('resize', () => {
    headerHeight = header.offsetHeight;
    body.style.setProperty('--header-height', `${headerHeight}px`);
  });
}
